const toggleClassModifiers = (arr, options = { add: false, remove: false }) => {
	arr.forEach(itm => {
		const [node, classModifier] = itm;
		if (node) {
			if (options.add === true) node.classList.add(classModifier);
			else if (options.remove === true) node.classList.remove(classModifier);
			else node.classList.toggle(classModifier);
		}
	});
};

export default toggleClassModifiers;
